// extracted by mini-css-extract-plugin
export default {"favorite_btn":"FavoriteButton_favorite_btn__MhHzH","active":"FavoriteButton_active__Jpl1H"};